export default {
  types: [
    {
      type: "A",
      list: [
        {
          seq: 1,
          gameName: "邪瞳专属单职业",
          ip: "180版版",
          line: "新职业丰富玩法",
          intro: "职业丰富长久耐玩追梦★",
          qq: "灬纯PC推",
          gameId: 3800097,
          boxGameName: "邪瞳专属单职业"
        },
        {
          seq: 2,
          gameName: "黄泉火龙大极品▃",
          ip: "长久火龙专属★",
          line: "※上线领礼爽",
          intro: "━上线领礼双号开荒多图打宝燃★",
          qq: "※火龙打宝追梦服",
          gameId: 3800096,
          boxGameName: "黄泉火龙大极品"
        },
        {
          seq: 3,
          gameName: "道观复古沉默",
          ip: "灬沉默★专属",
          line: "█全新等级好升",
          intro: "等级好升多◆图打宝打金服",
          qq: "沉默专属▃",
          gameId: 3800109,
          boxGameName: "道观复古沉默"
        },
        {
          seq: 4,
          gameName: "文狸墨竹特戒▃",
          ip: "爆经█典复古〃",
          line: "新区连开稳",
          intro: "新区连开散人友好多图打宝散人必玩▃",
          qq: "复古怀◆旧散人服",
          gameId: 3800053,
          boxGameName: "文狸墨竹特戒"
        },
        {
          seq: 5,
          gameName: "纯PC小呆瓜破坏神╊",
          ip: "※长久特色传奇",
          line: "◆特色·玩法",
          intro: "▁特色玩法经典耐玩冲▃",
          qq: "纯PC※推玩法╊",
          gameId: 3800002,
          boxGameName: "纯PC小呆瓜破坏神"
        },
        {
          seq: 6,
          gameName: "琴台神◆器专属",
          ip: "▲真神器专属◆",
          line: "装备回收爆▃",
          intro: "灬装备回收等级好升多图打宝长期真耐玩",
          qq: "神器追※梦玩法╊",
          gameId: 3800086,
          boxGameName: "琴台神器专属"
        },
        {
          seq: 7,
          gameName: "◆霁月火·龙单职业",
          ip: "※火龙专属",
          line: "新区连开首战区★",
          intro: "新区连开长久耐玩装备靠打╊",
          qq: "※火龙打宝爽",
          gameId: 3800088,
          boxGameName: "霁月火龙单职业"
        },
        {
          seq: 8,
          gameName: "朱砂战神三职业",
          ip: "180版可搬砖",
          line: "长久散人友好▃",
          intro: "※散人友好无坑公平神宠助战冲",
          qq: "复古怀旧▃",
          gameId: 3800101,
          boxGameName: "朱砂战神三职业"
        },
        {
          seq: 9,
          gameName: "※裂空神器专属",
          ip: "神器专属╊",
          line: "爆率全开新区",
          intro: "爆率全开无█坑公平追梦〃",
          qq: "◆神器·追梦",
          gameId: 3800094,
          boxGameName: "裂空神器专属"
        },
        {
          seq: 10,
          gameName: "█怒雷天之冰雪",
          ip: "※长久冰雪复古",
          line: "█新区连开区",
          intro: "新区连开特◆色玩法首战区",
          qq: "▁纯PC推真耐玩",
          gameId: 3800075,
          boxGameName: "怒雷天之冰雪"
        },
        {
          seq: 11,
          gameName: "█归鸦沉默单职业",
          ip: "新沉█默单职〃",
          line: "职业丰富爽▃",
          intro: "职业丰富长久耐玩专属神器新区首战",
          qq: "※沉默专属首战区",
          gameId: 3800092,
          boxGameName: "归鸦沉默单职业"
        },
        {
          seq: 12,
          gameName: "沉默华夏▃",
          ip: "◆沉默·专属",
          line: "经典特◆色玩法",
          intro: "※特色玩法经典耐玩热血开荒·",
          qq: "▁沉默专属",
          gameId: 111661,
          boxGameName: "沉默华夏"
        },
        {
          seq: 13,
          gameName: "◆书斋迷·失神器",
          ip: "经典神器专属系统",
          line: "※装备靠打玩法·",
          intro: "※装备靠打无坑公平多图打宝燃",
          qq: "灬神器追梦爆",
          gameId: 3800105,
          boxGameName: "书斋迷失神器"
        },
        {
          seq: 14,
          gameName: "▁刀域神器专属▃",
          ip: "◆神器·专属",
          line: "长久多图打宝★",
          intro: "※多图打宝零氪畅玩打金服·",
          qq: "神器追梦★",
          gameId: 3800102,
          boxGameName: "刀域神器专属"
        },
        {
          seq: 15,
          gameName: "灬玄策沉★默专属",
          ip: "▁沉默三职",
          line: "新区连※开玩法╊",
          intro: "新区连开泡点升级开战",
          qq: "沉默专属爆★",
          gameId: 3800049,
          boxGameName: "玄策沉默专属"
        },
        {
          seq: 16,
          gameName: "酒庐传奇1★",
          ip: "新特█色传奇〃",
          line: "特色玩法散人首选",
          intro: "━特色玩法经典耐玩爽★",
          qq: "※纯PC推模式·",
          gameId: 3800107,
          boxGameName: "酒庐传奇1"
        },
        {
          seq: 17,
          gameName: "灬血池攻速无限刀",
          ip: "180版玩法",
          line: "长久多图打宝▃",
          intro: "※多图打宝魔王高爆打金服·",
          qq: "█神器追梦",
          gameId: 3800095,
          boxGameName: "血池攻速无限刀"
        },
        {
          seq: 18,
          gameName: "※刀域火龙",
          ip: "火龙专属★",
          line: "装备回收必体验╊",
          intro: "灬装备回收首爆奖励职业丰富散人来追梦",
          qq: "神器追梦爽▃",
          gameId: 3800081,
          boxGameName: "刀域火龙"
        },
        {
          seq: 19,
          gameName: "无定赤月大极品",
          ip: "▲真特色传奇◆",
          line: "新区连开首战区",
          intro: "新区连开散◆人友好散人服",
          qq: "█散人推荐可搬砖",
          gameId: 3800080,
          boxGameName: "无定赤月大极品"
        },
        {
          seq: 20,
          gameName: "※霁月攻速单职业",
          ip: "神器专属首战区〃",
          line: "职业丰富╊",
          intro: "职业丰富散人友好必玩",
          qq: "经典神器追梦〃",
          gameId: 3800054,
          boxGameName: "霁月攻速单职业"
        },
        {
          seq: 21,
          gameName: "灬墨染微变单职业",
          ip: "▁特色单职区",
          line: "长久长久耐玩★",
          intro: "▁长久耐玩等级好升多图打宝首战区",
          qq: "※散人推荐",
          gameId: 3800078,
          boxGameName: "墨染微变单职业"
        },
        {
          seq: 22,
          gameName: "墨杀攻速单职业▃",
          ip: "▁特色单职必体验",
          line: "※长久耐玩",
          intro: "◆长久耐玩装·备靠打刚开服",
          qq: "█全新攻速推荐",
          gameId: 3800045,
          boxGameName: "墨杀攻速单职业"
        },
        {
          seq: 23,
          gameName: "素霓传奇2▃",
          ip: "灬特色★传奇",
          line: "长久特色玩法▃",
          intro: "特色玩法经典耐玩热血开荒追梦",
          qq: "纯PC推★",
          gameId: 3800104,
          boxGameName: "素霓传奇2"
        },
        {
          seq: 24,
          gameName: "灬断猿摸金传奇",
          ip: "176版玩法",
          line: "魔王◆高爆",
          intro: "魔王高爆切割狂暴散人友好长久耐玩▃",
          qq: "爆复█古怀旧〃",
          gameId: 3800093,
          boxGameName: "断猿摸金传奇"
        },
        {
          seq: 25,
          gameName: "※禅院传奇1",
          ip: "特色传奇〃",
          line: "▁特色玩法追梦服",
          intro: "※特色玩法经典耐玩热血开荒冲",
          qq: "灬纯★PC推",
          gameId: 3800108,
          boxGameName: "禅院传奇1"
        },
        {
          seq: 26,
          gameName: "灬暮雪沉★默三职业",
          ip: "灬沉默三职",
          line: "多图打宝追梦服〃",
          intro: "※多图打宝等级好升装备回收爆",
          qq: "※沉默专属爆",
          gameId: 3800090,
          boxGameName: "暮雪沉默三职业"
        },
        {
          seq: 27,
          gameName: "残照狂█徒迷失〃",
          ip: "特色传奇爽",
          line: "新切割狂暴",
          intro: "切割狂暴等级好升神宠助战",
          qq: "▲真高爆推荐◆",
          gameId: 3800089,
          boxGameName: "残照狂徒迷失"
        },
        {
          seq: 28,
          gameName: "书斋沉默专属",
          ip: "爆沉默专属专服",
          line: "灬泡点升级真耐玩",
          intro: "※泡点升级多图打宝职业丰富爽",
          qq: "沉默专属稳〃",
          gameId: 3800110,
          boxGameName: "书斋沉默专属"
        },
        {
          seq: 29,
          gameName: "灬无常专★属神器",
          ip: "长久无限刀版专服",
          line: "▁首爆奖励首战区",
          intro: "首爆奖励装备回收多图打宝开战〃",
          qq: "神器追梦",
          gameId: 3800100,
          boxGameName: "无常专属神器"
        },
        {
          seq: 30,
          gameName: "未休魅影骷髅王",
          ip: "特色传奇真耐玩〃",
          line: "新区◆连开",
          intro: "新区连开无坑公平长久耐玩╊",
          qq: "经典纯◆PC推",
          gameId: 3800057,
          boxGameName: "未休魅影骷髅王"
        },
        {
          seq: 31,
          gameName: "踵武仙剑沉默",
          ip: "※沉默专属首战区",
          line: "新区连开╊",
          intro: "◆新区连开·泡点升级",
          qq: "长久沉默专属▃",
          gameId: 3800060,
          boxGameName: "踵武仙剑沉默"
        },
        {
          seq: 32,
          gameName: "钜峰复古沉默★",
          ip: "沉默专属散人服★",
          line: "※新区连开",
          intro: "新区连开长久耐玩上线领礼╊",
          qq: "新沉█默专属〃",
          gameId: 3800050,
          boxGameName: "钜峰复古沉默"
        },
        {
          seq: 33,
          gameName: "衍月灵猫传奇",
          ip: "全新176版╊",
          line: "灬新区★连开",
          intro: "新区连开职业丰富开战★",
          qq: "复古怀旧",
          gameId: 3800052,
          boxGameName: "衍月灵猫传奇"
        },
        {
          seq: 34,
          gameName: "枯荷高爆神器▃",
          ip: "█神器专属爽",
          line: "新装备靠打模式",
          intro: "装备靠打多◆图打宝打金服",
          qq: "█神器追梦",
          gameId: 3800056,
          boxGameName: "枯荷高爆神器"
        },
        {
          seq: 35,
          gameName: "啼鹃变速狂刀",
          ip: "185版追梦服★",
          line: "真激情攻沙",
          intro: "激情攻沙零氪畅玩多图打宝首战区",
          qq: "全新纯PC推╊",
          gameId: 3800062,
          boxGameName: "啼鹃变速狂刀"
        },
        {
          seq: 36,
          gameName: "※归鸦无限刀·",
          ip: "长久无限刀版▃",
          line: "货币可打爽╊",
          intro: "█货币可打上线领礼冲",
          qq: "攻速推荐真耐玩★",
          gameId: 3800059,
          boxGameName: "归鸦无限刀"
        },
        {
          seq: 37,
          gameName: "画舫微◆变三职业",
          ip: "180版模式",
          line: "专属神器╊",
          intro: "专属神器职◆业丰富散人服",
          qq: "新神█器追梦〃",
          gameId: 3800106,
          boxGameName: "画舫微变三职业"
        },
        {
          seq: 38,
          gameName: "琴台攻※速无限刀╊",
          ip: "真无限刀版系统",
          line: "※专属神器爽",
          intro: "专属神器多图打宝首战区",
          qq: "※沉默专属模式·",
          gameId: 3800103,
          boxGameName: "琴台攻速无限刀"
        },
        {
          seq: 39,
          gameName: "▲墨染微变三职业◆",
          ip: "※经典三职首战区",
          line: "爆率全开▃",
          intro: "爆率全开无◆坑公平散人服",
          qq: "爆高爆推荐新区",
          gameId: 3800099,
          boxGameName: "墨染微变三职业"
        },
        {
          seq: 40,
          gameName: "━裂空合击★",
          ip: "经典合击首战区",
          line: "经典多图打宝",
          intro: "多图打宝装备保※值特色玩法必玩╊",
          qq: "合击推荐",
          gameId: 3800066,
          boxGameName: "裂空合击"
        },
        {
          seq: 41,
          gameName: "※百破灵猫沉默",
          ip: "█沉默专属爽",
          line: "全新新区连开╊",
          intro: "灬新区连开多图打宝特色玩法长期真耐玩",
          qq: "沉默专属〃",
          gameId: 3800068,
          boxGameName: "百破灵猫沉默"
        },
        {
          seq: 42,
          gameName: "无常沉◆默三职业",
          ip: "长久沉默三职玩法",
          line: "新区连◆开追梦服",
          intro: "新区连开长◆久耐玩长久服",
          qq: "灬沉默★专属",
          gameId: 3800074,
          boxGameName: "无常沉默三职业"
        },
        {
          seq: 43,
          gameName: "刀藏诛仙专属",
          ip: "经典火龙专属〃",
          line: "灬新区连开爆",
          intro: "灬新区连开装备回收多图打宝长期真耐玩",
          qq: "火龙打宝新区",
          gameId: 3800048,
          boxGameName: "刀藏诛仙专属"
        },
        {
          seq: 44,
          gameName: "霜雪鲁王传奇▃",
          ip: "灬特色传奇追梦服",
          line: "▁新区连开",
          intro: "灬新区连开散人★友好多图打宝爽",
          qq: "经典散人推荐",
          gameId: 3800065,
          boxGameName: "霜雪鲁王传奇"
        },
        {
          seq: 45,
          gameName: "暮雪渝乐复古",
          ip: "神器专◆属追梦服",
          line: "█长久耐玩",
          intro: "灬长久耐玩装备靠打★等级好升激情开荒",
          qq: "▲真复古怀旧◆",
          gameId: 3800058,
          boxGameName: "暮雪渝乐复古"
        },
        {
          seq: 46,
          gameName: "枯荷180小极品〃",
          ip: "180※版玩法╊",
          line: "装备◆保值",
          intro: "装备保值装备回收泡点升级╊",
          qq: "灬经典散人推荐",
          gameId: 3800091,
          boxGameName: "枯荷180小极品"
        },
        {
          seq: 47,
          gameName: "素霓战神三职业",
          ip: "经典经典三职",
          line: "◆泡点·升级",
          intro: "※泡点升级神宠助战多图打宝燃",
          qq: "散人推◆荐可搬砖",
          gameId: 3800084,
          boxGameName: "素霓战神三职业"
        },
        {
          seq: 48,
          gameName: "※锈刀专属神器",
          ip: "█185版散人服",
          line: "专属神器",
          intro: "█专属神器装备回收冲",
          qq: "经典沉默专属〃",
          gameId: 3800098,
          boxGameName: "锈刀专属神器"
        },
        {
          seq: 49,
          gameName: "朱砂复古沉默〃",
          ip: "沉默专属追梦服〃",
          line: "智能挂机▃",
          intro: "智能挂机神宠助战货币可打散人服",
          qq: "经典沉默专属〃",
          gameId: 3800079,
          boxGameName: "朱砂复古沉默"
        },
        {
          seq: 50,
          gameName: "断猿沉默专属▃",
          ip: "※沉默专属",
          line: "切割狂暴追梦服★",
          intro: "切割狂暴专◆属神器打金服",
          qq: "沉默专属散人服",
          gameId: 3800063,
          boxGameName: "断猿沉默专属"
        },
        {
          seq: 51,
          gameName: "血池火龙三职业",
          ip: "█火龙专属爽",
          line: "▁全新装备靠打",
          intro: "▁装备靠打新区连开多图打宝刚开服",
          qq: "灬火龙打宝",
          gameId: 3800067,
          boxGameName: "血池火龙三职业"
        },
        {
          seq: 52,
          gameName: "▁邪瞳无限刀▃",
          ip: "※无限刀版爆",
          line: "※长久神宠助战",
          intro: "▁神宠助战泡点升级切割狂暴散人服",
          qq: "※神器追梦",
          gameId: 3800073,
          boxGameName: "邪瞳无限刀"
        },
        {
          seq: 53,
          gameName: "█展锋飞羽沉默",
          ip: "沉默三职玩法",
          line: "※新区连开",
          intro: "█新区连开泡点升级爽",
          qq: "经典沉默专属〃",
          gameId: 3800051,
          boxGameName: "展锋飞羽沉默"
        },
        {
          seq: 54,
          gameName: "墨杀神器单职业",
          ip: "▲新神器专属◆",
          line: "灬装备保值区",
          intro: "装备保值长久耐玩首战区",
          qq: "灬神器追梦追梦服",
          gameId: 3800087,
          boxGameName: "墨杀神器单职业"
        },
        {
          seq: 55,
          gameName: "锈刀微变三职业",
          ip: "长久经典复古★",
          line: "◆职业·丰富",
          intro: "█职业丰富等级好升冲",
          qq: "复古怀旧散人服〃",
          gameId: 3800064,
          boxGameName: "锈刀微变三职业"
        },
        {
          seq: 56,
          gameName: "━黄泉复古三职业★",
          ip: "176版稳╊",
          line: "▁全新魔王高爆",
          intro: "灬魔王高爆多图打宝装备回收新区抢首战",
          qq: "复古◆怀旧",
          gameId: 3800071,
          boxGameName: "黄泉复古三职业"
        },
        {
          seq: 57,
          gameName: "2003记忆传奇",
          ip: "爆特色传奇",
          line: "※特色玩法可搬砖",
          intro: "灬特色玩法经典耐玩热血开荒新区抢首战",
          qq: "纯PC推散人首选",
          gameId: 111188,
          boxGameName: "2003记忆传奇"
        },
        {
          seq: 58,
          gameName: "残照迷◆失单职业",
          ip: "◆神器·专属",
          line: "▲真长久耐玩◆",
          intro: "灬长久耐玩装备靠打等级好升散人来追梦",
          qq: "▁神器追梦",
          gameId: 3800055,
          boxGameName: "残照迷失单职业"
        },
        {
          seq: 59,
          gameName: "碧影王土无限刀",
          ip: "无限刀版★",
          line: "灬新区连开散人服",
          intro: "灬新区连开上线领礼多图打宝骨灰来开荒",
          qq: "攻速推荐区〃",
          gameId: 3800061,
          boxGameName: "碧影王土无限刀"
        },
        {
          seq: 60,
          gameName: "灬酒庐复古大陆",
          ip: "长久经典复古▃",
          line: "装备靠打散人首选",
          intro: "装备靠打无◆坑公平散人服",
          qq: "复古怀旧可搬砖▃",
          gameId: 3800107,
          boxGameName: "酒庐复古大陆"
        },
        {
          seq: 61,
          gameName: "灬素霓万★尊复古",
          ip: "全新176版路线",
          line: "装备回※收玩法╊",
          intro: "▁装备回收散人友好多图打宝散人服",
          qq: "复古怀旧追梦服",
          gameId: 3800104,
          boxGameName: "素霓万尊复古"
        },
        {
          seq: 62,
          gameName: "▁禅院复古三职业▃",
          ip: "沉默三职稳",
          line: "长久多图打宝▃",
          intro: "※多图打宝职业丰富打金服·",
          qq: "沉默专属▃",
          gameId: 3800108,
          boxGameName: "禅院复古三职业"
        },
        {
          seq: 63,
          gameName: "画舫幻影火龙",
          ip: "火龙专属长久耐玩",
          line: "▲新装备靠打◆",
          intro: "▁装备靠打无坑公平多图打宝刚开服",
          qq: "▁火龙打宝",
          gameId: 3800111,
          boxGameName: "画舫幻影火龙"
        },
        {
          seq: 64,
          gameName: "█酒庐创世魔神",
          ip: "※特色传奇",
          line: "装备靠打首战区",
          intro: "装备靠打无坑公平追梦★",
          qq: "灬高爆★推荐",
          gameId: 3800112,
          boxGameName: "酒庐创世魔神"
        },
        {
          seq: 65,
          gameName: "灬啼鹃迷★失无限刀",
          ip: "▁无限刀版",
          line: "专属神※器玩法╊",
          intro: "专属神器神宠助战散人友好╊",
          qq: "神器追梦爆★",
          gameId: 3800117,
          boxGameName: "啼鹃迷失无限刀"
        },
        {
          seq: 66,
          gameName: "墨杀暗◆黑大陆",
          ip: "特色传奇散人服〃",
          line: "装备靠打〃",
          intro: "装备靠打无坑公平多图打宝耐玩〃",
          qq: "爆高爆推荐专服",
          gameId: 3800119,
          boxGameName: "墨杀暗黑大陆"
        },
        {
          seq: 67,
          gameName: "道观微※变三职业╊",
          ip: "长久经典三职★",
          line: "长久耐玩区╊",
          intro: "长久耐玩激◆情攻沙长久服",
          qq: "█高爆推荐追梦服",
          gameId: 3800116,
          boxGameName: "道观微变三职业"
        },
        {
          seq: 68,
          gameName: "禅院神◆器专属",
          ip: "180版╊",
          line: "※职业丰富模式·",
          intro: "职业丰富上◆线领礼首战区",
          qq: "▁神器追梦区",
          gameId: 3800113,
          boxGameName: "禅院神器专属"
        },
        {
          seq: 69,
          gameName: "灬残照星★河大陆",
          ip: "爆神器专属系统",
          line: "装备回收爆",
          intro: "装备回收专◆属神器散人服",
          qq: "神器追梦版",
          gameId: 3800131,
          boxGameName: "残照星河大陆"
        },
        {
          seq: 70,
          gameName: "暮雪八荒神器",
          ip: "经典◆180版",
          line: "专属神器爆〃",
          intro: "专属神器魔王高爆多图打宝起飞〃",
          qq: "神器追梦",
          gameId: 3800132,
          boxGameName: "暮雪八荒神器"
        },
        {
          seq: 71,
          gameName: "━枯荷嘟嘟专属★",
          ip: "灬专属★神器",
          line: "经典神宠助战〃",
          intro: "神宠助战魔※王高爆开战╊",
          qq: "※纯PC推",
          gameId: 3800133,
          boxGameName: "枯荷嘟嘟专属"
        },
        {
          seq: 72,
          gameName: "断猿战※神三职业╊",
          ip: "爆█180版〃",
          line: "▁魔王高爆稳",
          intro: "魔王高爆多图打宝特色玩法激情开荒▃",
          qq: "高爆推荐散人服",
          gameId: 3800140,
          boxGameName: "断猿战神三职业"
        },
        {
          seq: 73,
          gameName: "霁月迷失神器",
          ip: "█185版",
          line: "专属神器追梦服▃",
          intro: "灬专属神器职业丰富长久耐玩骨灰来开荒",
          qq: "灬神器★追梦",
          gameId: 3800129,
          boxGameName: "霁月迷失神器"
        },
        {
          seq: 74,
          gameName: "灬啼鹃专★属大极品",
          ip: "真专属神器路线",
          line: "▁多图打宝追梦服",
          intro: "多图打宝魔王高爆装备回收╊",
          qq: "※高爆推荐爆",
          gameId: 3800135,
          boxGameName: "啼鹃专属大极品"
        },
        {
          seq: 75,
          gameName: "灬归鸦神器微变",
          ip: "神器专※属玩法╊",
          line: "※首爆奖励",
          intro: "灬首爆奖励泡点升★级切割狂暴起飞",
          qq: "新神器追梦",
          gameId: 3800134,
          boxGameName: "归鸦神器微变"
        },
        {
          seq: 76,
          gameName: "血池弑神复古",
          ip: "185◆版",
          line: "职业丰◆富追梦服",
          intro: "职业丰富上线领礼追梦",
          qq: "复古◆怀旧区",
          gameId: 3800145,
          boxGameName: "血池弑神复古"
        },
        {
          seq: 77,
          gameName: "朱砂专属无限刀★",
          ip: "爆无限刀版",
          line: "多图打※宝玩法╊",
          intro: "多图打宝魔王高爆首战区",
          qq: "攻速◆推荐稳",
          gameId: 3800153,
          boxGameName: "朱砂专属无限刀"
        },
        {
          seq: 78,
          gameName: "◆酒庐火·龙复古",
          ip: "火龙专属╊",
          line: "※爆率全开首战区",
          intro: "▲爆率全开无坑公平起飞◆",
          qq: "灬复古★怀旧",
          gameId: 3800159,
          boxGameName: "酒庐火龙复古"
        },
        {
          seq: 79,
          gameName: "刀域复◆古小极品",
          ip: "新█180版〃",
          line: "▁职业丰富区",
          intro: "职业丰富激情攻沙多图打宝必玩〃",
          qq: "复古怀旧可搬砖★",
          gameId: 3800154,
          boxGameName: "刀域复古小极品"
        },
        {
          seq: 80,
          gameName: "锈刀沉默三职业〃",
          ip: "沉默三职",
          line: "爆神宠助战",
          intro: "█神宠助战等级好升爆",
          qq: "沉默专属╊",
          gameId: 3800142,
          boxGameName: "锈刀沉默三职业"
        },
        {
          seq: 81,
          gameName: "素霓复古沉默╊",
          ip: "沉默三职★",
          line: "神宠助战可搬砖〃",
          intro: "▁神宠助战职业丰富特色玩法打金服",
          qq: "沉默专属稳",
          gameId: 3800155,
          boxGameName: "素霓复古沉默"
        },
        {
          seq: 82,
          gameName: "道观悟法专属〃",
          ip: "◆神器·专属",
          line: "长久攻速拉满★",
          intro: "攻速拉满专◆属神器散人服",
          qq: "全新神器追梦玩法",
          gameId: 3800161,
          boxGameName: "道观悟法专属"
        },
        {
          seq: 83,
          gameName: "※琴台复古三职业",
          ip: "长久经典复古▃",
          line: "魔王◆高爆区",
          intro: "█魔王高爆职业丰富冲",
          qq: "复古怀旧真耐玩",
          gameId: 3800156,
          boxGameName: "琴台复古三职业"
        },
        {
          seq: 84,
          gameName: "裂空专属单职业",
          ip: "180版必体验",
          line: "▲真多图打宝◆",
          intro: "多图打宝切◆割狂暴首战区",
          qq: "※神器追梦",
          gameId: 3800143,
          boxGameName: "裂空专属单职业"
        },
        {
          seq: 85,
          gameName: "无常焚天大陆╊",
          ip: "▁特色传奇稳",
          line: "爆上█线领礼〃",
          intro: "上线领礼等级好※升多图打宝打金服╊",
          qq: "真高爆推荐",
          gameId: 3800151,
          boxGameName: "无常焚天大陆"
        },
        {
          seq: 86,
          gameName: "◆画舫神·器专属",
          ip: "神器◆专属",
          line: "※攻速拉满玩法·",
          intro: "攻速拉满专属神器魔王高爆爆",
          qq: "神器追梦稳╊",
          gameId: 3800158,
          boxGameName: "画舫神器专属"
        },
        {
          seq: 87,
          gameName: "█邪瞳凛破单职业",
          ip: "特色单◆职可搬砖",
          line: "上线领礼〃",
          intro: "▁上线领礼等级好升多图打宝首战区",
          qq: "▲新纯PC推◆",
          gameId: 3800150,
          boxGameName: "邪瞳凛破单职业"
        },
        {
          seq: 88,
          gameName: "禅院天命专属★",
          ip: "爆神█器专属〃",
          line: "攻速拉满爆〃",
          intro: "━攻速拉满专属神器刚开服★",
          qq: "灬神器追梦首战区",
          gameId: 3800160,
          boxGameName: "禅院天命专属"
        },
        {
          seq: 89,
          gameName: "墨杀创世微变",
          ip: "全新神器专属",
          line: "攻速拉满首战区▃",
          intro: "▲攻速拉满专属神器多图打宝冲◆",
          qq: "灬神器★追梦",
          gameId: 3800162,
          boxGameName: "墨杀创世微变"
        },
        {
          seq: 90,
          gameName: "霁月斩█墟大极品〃",
          ip: "神器专属可搬砖★",
          line: "攻速拉满★",
          intro: "灬攻速拉满★专属神器冲",
          qq: "▁全新神器追梦",
          gameId: 3800163,
          boxGameName: "霁月斩墟大极品"
        },
        {
          seq: 91,
          gameName: "墨染神器单职业▃",
          ip: "◆神器·专属",
          line: "经典爆率全开〃",
          intro: "爆率全开多图打宝开战★",
          qq: "全新神器追梦",
          gameId: 3800152,
          boxGameName: "墨染神器单职业"
        },
        {
          seq: 92,
          gameName: "█黄泉专属单职业",
          ip: "180◆版爆",
          line: "▁全新专属神器",
          intro: "█专属神器多图打宝燃",
          qq: "※神器追梦",
          gameId: 3800147,
          boxGameName: "黄泉专属单职业"
        }
      ]
    },
    {
      type: "B",
      list: [
        {
          seq: 1,
          gameName: "邪瞳专属单职业",
          ip: "真特色单职系统",
          line: "长久耐玩可搬砖",
          intro: "长久耐玩多图打◆宝等级好升长久服",
          qq: "特色推荐爆▃",
          gameId: 3800097,
          boxGameName: "邪瞳专属单职业"
        },
        {
          seq: 2,
          gameName: "▁黄泉火龙大极品▃",
          ip: "█火龙打宝追梦服",
          line: "双号开荒〃",
          intro: "※双号开荒材料可打多图打宝长期真耐玩",
          qq: "━新特色推荐★",
          gameId: 3800096,
          boxGameName: "黄泉火龙大极品"
        },
        {
          seq: 3,
          gameName: "道观复古沉默",
          ip: "复古◆长服",
          line: "灬多图打宝真耐玩",
          intro: "▁多图打宝爆率全开职业丰富长久服▃",
          qq: "▁高爆推荐爽",
          gameId: 3800109,
          boxGameName: "道观复古沉默"
        },
        {
          seq: 4,
          gameName: "灬文狸墨竹特戒",
          ip: "█经典三职首战区",
          line: "爆散人友好模式",
          intro: "※散人友好魔王高爆爆·",
          qq: "━真魔王推荐★",
          gameId: 3800053,
          boxGameName: "文狸墨竹特戒"
        },
        {
          seq: 5,
          gameName: "━纯PC小呆瓜破坏神★",
          ip: "◆纯PC·服模式",
          line: "经典耐玩★",
          intro: "█经典耐玩操作简单热血开荒冲",
          qq: "经典特◆色推荐",
          gameId: 3800002,
          boxGameName: "纯PC小呆瓜破坏神"
        },
        {
          seq: 6,
          gameName: "琴台神器专属╊",
          ip: "神器追梦首战区〃",
          line: "灬等级好升",
          intro: "等级好升专属神器打金服▃",
          qq: "经典特◆色推荐",
          gameId: 3800086,
          boxGameName: "琴台神器专属"
        },
        {
          seq: 7,
          gameName: "※霁月火龙单职业",
          ip: "特色※单职╊",
          line: "━新长久耐玩★",
          intro: "长久耐玩等级好◆升装备靠打散人服",
          qq: "特色推荐〃",
          gameId: 3800088,
          boxGameName: "霁月火龙单职业"
        },
        {
          seq: 8,
          gameName: "朱砂战神三职业",
          ip: "经典三职",
          line: "▁无坑公平追梦服",
          intro: "无坑公平装备回收爽〃",
          qq: "※特色推荐·",
          gameId: 3800101,
          boxGameName: "朱砂战神三职业"
        },
        {
          seq: 9,
          gameName: "裂空神器专属〃",
          ip: "※神器追梦·",
          line: "长久无坑公平玩法",
          intro: "无坑公平魔王高爆多图打宝起飞★",
          qq: "※魔王推荐",
          gameId: 3800094,
          boxGameName: "裂空神器专属"
        },
        {
          seq: 10,
          gameName: "▁怒雷天之冰雪▃",
          ip: "纯PC服可搬砖╊",
          line: "特色玩法★",
          intro: "※特色玩法热血开荒经典耐玩冲·",
          qq: "长久特色推荐▃",
          gameId: 3800075,
          boxGameName: "怒雷天之冰雪"
        },
        {
          seq: 11,
          gameName: "▁归鸦沉默单职业▃",
          ip: "※特色单职可搬砖",
          line: "灬长久耐玩",
          intro: "长久耐玩新区连开开战",
          qq: "━新特色推荐★",
          gameId: 3800092,
          boxGameName: "归鸦沉默单职业"
        },
        {
          seq: 12,
          gameName: "▁沉默华夏",
          ip: "沉默专属▃",
          line: "经典耐玩必体验★",
          intro: "经典耐玩操作简单爽〃",
          qq: "※特色推荐·",
          gameId: 111661,
          boxGameName: "沉默华夏"
        },
        {
          seq: 13,
          gameName: "书斋迷◆失神器",
          ip: "神器追梦今日首战",
          line: "长久无坑公平★",
          intro: "无坑公平魔王高爆多图打宝散人必玩╊",
          qq: "█魔王推荐",
          gameId: 3800105,
          boxGameName: "书斋迷失神器"
        },
        {
          seq: 14,
          gameName: "刀域神器专属▃",
          ip: "神器◆追梦",
          line: "█零氪畅玩散人服",
          intro: "※零氪畅玩装备回收专属神器长期真耐玩",
          qq: "※特色推荐·",
          gameId: 3800102,
          boxGameName: "刀域神器专属"
        },
        {
          seq: 15,
          gameName: "玄策沉默专属╊",
          ip: "※经典三职·",
          line: "经典泡点升级〃",
          intro: "泡点升级货币可打神宠助战爆",
          qq: "货币◆推荐",
          gameId: 3800049,
          boxGameName: "玄策沉默专属"
        },
        {
          seq: 16,
          gameName: "酒庐◆传奇1",
          ip: "纯PC服可搬砖★",
          line: "爆经典耐玩",
          intro: "█经典耐玩操作简单热血开荒燃",
          qq: "█全新特色推荐",
          gameId: 3800107,
          boxGameName: "酒庐传奇1"
        },
        {
          seq: 17,
          gameName: "血池攻※速无限刀╊",
          ip: "经典神器追梦模式",
          line: "▁魔王高爆可搬砖",
          intro: "※魔王高爆专属神器散人友好散人来追梦",
          qq: "灬特色推荐爽",
          gameId: 3800095,
          boxGameName: "血池攻速无限刀"
        },
        {
          seq: 18,
          gameName: "刀域火龙〃",
          ip: "经典※三职╊",
          line: "※长久首爆奖励",
          intro: "首爆奖励泡点升级刚开服▃",
          qq: "灬升级推荐",
          gameId: 3800081,
          boxGameName: "刀域火龙"
        },
        {
          seq: 19,
          gameName: "无定赤月大极品",
          ip: "纯PC服追梦服〃",
          line: "散人友好",
          intro: "散人友好泡点※升级魔王高爆爆╊",
          qq: "▁爆升级推荐▃",
          gameId: 3800080,
          boxGameName: "无定赤月大极品"
        },
        {
          seq: 20,
          gameName: "霁月攻速单职业╊",
          ip: "━真特色单职★",
          line: "散人◆友好区",
          intro: "散人友好装备回收自动回收刚开服",
          qq: "灬特色推★荐模式",
          gameId: 3800054,
          boxGameName: "霁月攻速单职业"
        },
        {
          seq: 21,
          gameName: "※墨染微变单职业·",
          ip: "特色单职▃",
          line: "█等级好升可搬砖",
          intro: "▁等级好升新区连开必玩▃",
          qq: "特色※推荐╊",
          gameId: 3800078,
          boxGameName: "墨染微变单职业"
        },
        {
          seq: 22,
          gameName: "◆墨杀攻·速单职业",
          ip: "长久特色单职▃",
          line: "装备※靠打╊",
          intro: "※装备靠打等级好升攻速拉满散人来追梦",
          qq: "灬特色推★荐玩法",
          gameId: 3800045,
          boxGameName: "墨杀攻速单职业"
        },
        {
          seq: 23,
          gameName: "▁素霓传奇2",
          ip: "█纯PC服",
          line: "▁经典耐玩可搬砖",
          intro: "经典耐玩操作简单开战",
          qq: "特色※推荐╊",
          gameId: 3800104,
          boxGameName: "素霓传奇2"
        },
        {
          seq: 24,
          gameName: "◆断猿摸·金传奇",
          ip: "长久高爆专服系统",
          line: "切割※狂暴╊",
          intro: "▲切割狂暴特色玩法长久服◆",
          qq: "█特色推荐散人服",
          gameId: 3800093,
          boxGameName: "断猿摸金传奇"
        },
        {
          seq: 25,
          gameName: "▲禅院传奇1◆",
          ip: "※纯PC服爆",
          line: "长久经典耐玩▃",
          intro: "◆经典耐玩操作简·单热血开荒首战区",
          qq: "▁特色推荐",
          gameId: 3800108,
          boxGameName: "禅院传奇1"
        },
        {
          seq: 26,
          gameName: "暮雪沉默三职业╊",
          ip: "经典三职稳▃",
          line: "▁全新等级好升",
          intro: "等级好升职业丰富装备回收激情开荒╊",
          qq: "特色推荐〃",
          gameId: 3800090,
          boxGameName: "暮雪沉默三职业"
        },
        {
          seq: 27,
          gameName: "残照狂徒迷失╊",
          ip: "爆高爆专服玩法",
          line: "等级好升稳",
          intro: "等级好升多图打宝神宠助战激情开荒╊",
          qq: "特色推荐可搬砖〃",
          gameId: 3800089,
          boxGameName: "残照狂徒迷失"
        },
        {
          seq: 28,
          gameName: "书斋沉默专属",
          ip: "沉默专属必体验",
          line: "█全新多图打宝",
          intro: "灬多图打宝装备回★收职业丰富首战区",
          qq: "▁特色推荐",
          gameId: 3800110,
          boxGameName: "书斋沉默专属"
        },
        {
          seq: 29,
          gameName: "█无常专属神器",
          ip: "神器追梦新区开荒",
          line: "▁爆装备回收▃",
          intro: "灬装备回收攻速拉满★多图打宝散人必玩",
          qq: "经典攻速推荐",
          gameId: 3800100,
          boxGameName: "无常专属神器"
        },
        {
          seq: 30,
          gameName: "未休魅影骷髅王",
          ip: "▁全新纯PC服",
          line: "无坑公平稳★",
          intro: "无坑公平特色玩法█长久耐玩散人必玩〃",
          qq: "特色推荐必体验★",
          gameId: 3800057,
          boxGameName: "未休魅影骷髅王"
        },
        {
          seq: 31,
          gameName: "踵武仙剑沉默",
          ip: "━新沉默专属★",
          line: "泡点◆升级稳",
          intro: "泡点升级魔王高爆装备回收起飞★",
          qq: "▁魔王推荐真耐玩",
          gameId: 3800060,
          boxGameName: "踵武仙剑沉默"
        },
        {
          seq: 32,
          gameName: "█钜峰复古沉默",
          ip: "━新复古长服★",
          line: "长久※耐玩╊",
          intro: "※长久耐玩神宠助战上线领礼散人来追梦",
          qq: "特色推荐追梦服★",
          gameId: 3800050,
          boxGameName: "钜峰复古沉默"
        },
        {
          seq: 33,
          gameName: "衍月灵猫传奇",
          ip: "灬经典三★职玩法",
          line: "█职业丰富",
          intro: "█职业丰富魔王高爆神宠助战冲",
          qq: "全新魔王推荐",
          gameId: 3800052,
          boxGameName: "衍月灵猫传奇"
        },
        {
          seq: 34,
          gameName: "枯荷高※爆神器╊",
          ip: "神器追梦★",
          line: "多图打宝真耐玩",
          intro: "多图打宝装备回收自动回收新区首战╊",
          qq: "※特色推荐区",
          gameId: 3800056,
          boxGameName: "枯荷高爆神器"
        },
        {
          seq: 35,
          gameName: "啼鹃变速狂刀",
          ip: "经典纯◆PC服",
          line: "零氪畅玩区",
          intro: "零氪畅玩切割狂暴首战区",
          qq: "特色推◆荐可搬砖",
          gameId: 3800062,
          boxGameName: "啼鹃变速狂刀"
        },
        {
          seq: 36,
          gameName: "※归鸦无限刀",
          ip: "▁纯PC服散人服",
          line: "※上线领礼",
          intro: "灬上线领礼经典耐玩特色玩法",
          qq: "经典特◆色推荐",
          gameId: 3800059,
          boxGameName: "归鸦无限刀"
        },
        {
          seq: 37,
          gameName: "画舫微变三职业★",
          ip: "全新经典三职路线",
          line: "职业◆丰富稳",
          intro: "▲职业丰富等级好升长久耐玩打金服◆",
          qq: "特色推荐首战区▃",
          gameId: 3800106,
          boxGameName: "画舫微变三职业"
        },
        {
          seq: 38,
          gameName: "灬琴台攻速无限刀",
          ip: "沉默专属首战区",
          line: "多图打宝〃",
          intro: "多图打宝切割狂暴散人友好开战",
          qq: "█全新特色推荐",
          gameId: 3800103,
          boxGameName: "琴台攻速无限刀"
        },
        {
          seq: 39,
          gameName: "墨染微变三职业★",
          ip: "━新经典三职★",
          line: "无坑※公平╊",
          intro: "无坑公平魔王高爆多图打宝散人必玩╊",
          qq: "█魔王推荐真耐玩",
          gameId: 3800099,
          boxGameName: "墨染微变三职业"
        },
        {
          seq: 40,
          gameName: "裂空合击〃",
          ip: "合击专服",
          line: "装备保值模式",
          intro: "装备保值经典耐玩散人服▃",
          qq: "特色推荐",
          gameId: 3800066,
          boxGameName: "裂空合击"
        },
        {
          seq: 41,
          gameName: "百破灵猫沉默╊",
          ip: "沉默专属★",
          line: "多图打◆宝真耐玩",
          intro: "━多图打宝经典耐玩特色玩法★",
          qq: "※特色推荐区",
          gameId: 3800068,
          boxGameName: "百破灵猫沉默"
        },
        {
          seq: 42,
          gameName: "无常沉默三职业╊",
          ip: "经典三职今日首战",
          line: "━真长久耐玩★",
          intro: "◆长久耐玩等级·好升装备靠打爽",
          qq: "特色推荐〃",
          gameId: 3800074,
          boxGameName: "无常沉默三职业"
        },
        {
          seq: 43,
          gameName: "刀藏诛仙专属",
          ip: "灬火龙打★宝模式",
          line: "█装备回收",
          intro: "※装备回收材料可打必玩·",
          qq: "全新特色推荐玩法",
          gameId: 3800048,
          boxGameName: "刀藏诛仙专属"
        },
        {
          seq: 44,
          gameName: "▁霜雪鲁王传奇",
          ip: "█全新纯PC服",
          line: "※散人友好·",
          intro: "▁散人友好装备回收开战",
          qq: "特色推荐路线",
          gameId: 3800065,
          boxGameName: "霜雪鲁王传奇"
        },
        {
          seq: 45,
          gameName: "暮雪渝乐复古",
          ip: "全新经典三职╊",
          line: "装备靠打服",
          intro: "█装备靠打装备保值等级好升燃",
          qq: "灬特色推荐散人服",
          gameId: 3800058,
          boxGameName: "暮雪渝乐复古"
        },
        {
          seq: 46,
          gameName: "灬枯荷180★小极品",
          ip: "经典纯◆PC服",
          line: "装备回收稳★",
          intro: "※装备回收散人友好泡点升级长期真耐玩",
          qq: "散人推荐可搬砖▃",
          gameId: 3800091,
          boxGameName: "枯荷180小极品"
        },
        {
          seq: 47,
          gameName: "素霓战神三职业",
          ip: "经典三职服",
          line: "※神宠助战",
          intro: "神宠助战魔王高※爆多图打宝首战区╊",
          qq: "全新魔王推荐╊",
          gameId: 3800084,
          boxGameName: "素霓战神三职业"
        },
        {
          seq: 48,
          gameName: "锈刀专属神器╊",
          ip: "▁爆沉默专属▃",
          line: "装备回收",
          intro: "装备回收多图打宝装备保值追梦★",
          qq: "※特色推荐追梦服",
          gameId: 3800098,
          boxGameName: "锈刀专属神器"
        },
        {
          seq: 49,
          gameName: "◆朱砂复·古沉默",
          ip: "━真复古长服★",
          line: "▁神宠助战爽",
          intro: "神宠助战装备回收打金服",
          qq: "灬特色推★荐模式",
          gameId: 3800079,
          boxGameName: "朱砂复古沉默"
        },
        {
          seq: 50,
          gameName: "灬断猿沉默专属",
          ip: "沉默※专属╊",
          line: "━新专属神器★",
          intro: "专属神器爆率全开多图打宝起飞★",
          qq: "高爆推荐",
          gameId: 3800063,
          boxGameName: "断猿沉默专属"
        },
        {
          seq: 51,
          gameName: "血池火龙三职业",
          ip: "爆经典三职",
          line: "新区连开追梦服〃",
          intro: "新区连开魔王高爆刚开服▃",
          qq: "魔王推荐区▃",
          gameId: 3800067,
          boxGameName: "血池火龙三职业"
        },
        {
          seq: 52,
          gameName: "灬邪瞳无限刀",
          ip: "神器追梦〃",
          line: "◆泡点升·级模式",
          intro: "泡点升级专属神器散人服▃",
          qq: "特色推荐爆╊",
          gameId: 3800073,
          boxGameName: "邪瞳无限刀"
        },
        {
          seq: 53,
          gameName: "◆展锋飞·羽沉默",
          ip: "长久经典三职系统",
          line: "泡点升级爽╊",
          intro: "泡点升级货币可打神宠助战起飞★",
          qq: "灬货币推★荐模式",
          gameId: 3800051,
          boxGameName: "展锋飞羽沉默"
        },
        {
          seq: 54,
          gameName: "墨杀神器单职业",
          ip: "◆特色单·职玩法",
          line: "█长久耐玩",
          intro: "长久耐玩魔王高爆激情攻沙必玩",
          qq: "▁真魔王推荐▃",
          gameId: 3800087,
          boxGameName: "墨杀神器单职业"
        },
        {
          seq: 55,
          gameName: "锈刀微变三职业",
          ip: "█经典三职追梦服",
          line: "等级◆好升",
          intro: "等级好升魔※王高爆散人服╊",
          qq: "▁真魔王推荐▃",
          gameId: 3800064,
          boxGameName: "锈刀微变三职业"
        },
        {
          seq: 56,
          gameName: "黄泉复古三职业〃",
          ip: "※经典三职",
          line: "多图打宝必体验〃",
          intro: "█多图打宝爆率全开装备回收冲",
          qq: "高爆※推荐╊",
          gameId: 3800071,
          boxGameName: "黄泉复古三职业"
        },
        {
          seq: 57,
          gameName: "2003记忆传奇",
          ip: "纯PC服服",
          line: "━新经典耐玩★",
          intro: "经典耐玩操作简单散人服▃",
          qq: "真特色推荐",
          gameId: 111188,
          boxGameName: "2003记忆传奇"
        },
        {
          seq: 58,
          gameName: "残照迷※失单职业╊",
          ip: "特色单职▃",
          line: "装备靠打追梦服〃",
          intro: "━装备靠打装备保值等级好升★",
          qq: "※特色推荐·",
          gameId: 3800055,
          boxGameName: "残照迷失单职业"
        },
        {
          seq: 59,
          gameName: "碧影王土无限刀",
          ip: "※高爆专服·",
          line: "▁真上线领礼▃",
          intro: "灬上线领礼散★人友好追梦",
          qq: "▁散人推荐",
          gameId: 3800061,
          boxGameName: "碧影王土无限刀"
        },
        {
          seq: 60,
          gameName: "█酒庐复古大陆",
          ip: "▁复古长服可搬砖",
          line: "真无坑公平",
          intro: "※无坑公平魔王高爆多图打宝冲·",
          qq: "━新魔王推荐★",
          gameId: 3800107,
          boxGameName: "酒庐复古大陆"
        },
        {
          seq: 61,
          gameName: "灬素霓万尊复古",
          ip: "复古长服散人首选",
          line: "灬经典散人友好",
          intro: "灬散人友好★装备保值",
          qq: "特色推荐〃",
          gameId: 3800104,
          boxGameName: "素霓万尊复古"
        },
        {
          seq: 62,
          gameName: "禅院复古三职业〃",
          ip: "真经典三职玩法",
          line: "◆职业丰·富模式",
          intro: "※职业丰富神宠助战激情攻沙长期真耐玩",
          qq: "▁特色推荐爆",
          gameId: 3800108,
          boxGameName: "禅院复古三职业"
        },
        {
          seq: 63,
          gameName: "画舫幻影火龙",
          ip: "新火龙打宝",
          line: "◆无坑公·平玩法",
          intro: "━无坑公平魔王高爆起飞★",
          qq: "魔王推荐爽〃",
          gameId: 3800111,
          boxGameName: "画舫幻影火龙"
        },
        {
          seq: 64,
          gameName: "酒庐创世魔神★",
          ip: "高爆专服爽╊",
          line: "无坑公平",
          intro: "█无坑公平魔王高爆多图打宝燃",
          qq: "灬魔王推荐",
          gameId: 3800112,
          boxGameName: "酒庐创世魔神"
        },
        {
          seq: 65,
          gameName: "啼鹃迷失无限刀〃",
          ip: "※神器追梦·",
          line: "经典神宠助战〃",
          intro: "灬神宠助战特色玩★法散人友好起飞",
          qq: "特色◆推荐",
          gameId: 3800117,
          boxGameName: "啼鹃迷失无限刀"
        },
        {
          seq: 66,
          gameName: "灬墨杀暗★黑大陆",
          ip: "▁真高爆专服▃",
          line: "※无坑公平区",
          intro: "▁无坑公平魔王高爆耐玩",
          qq: "魔王推荐追梦服",
          gameId: 3800119,
          boxGameName: "墨杀暗黑大陆"
        },
        {
          seq: 67,
          gameName: "▁道观微变三职业",
          ip: "█经典三职真耐玩",
          line: "※激情攻沙",
          intro: "激情攻沙多图打宝泡点升级起飞★",
          qq: "长久特色推荐★",
          gameId: 3800116,
          boxGameName: "道观微变三职业"
        },
        {
          seq: 68,
          gameName: "▲禅院神器专属◆",
          ip: "特色◆单职稳",
          line: "▁全新上线领礼",
          intro: "上线领礼切割狂暴神宠助战必玩★",
          qq: "特色推荐▃",
          gameId: 3800113,
          boxGameName: "禅院神器专属"
        },
        {
          seq: 69,
          gameName: "█残照星河大陆",
          ip: "神器追梦必体验",
          line: "新专属神器专服",
          intro: "专属神器魔王高爆多图打宝必玩★",
          qq: "新魔王推荐模式",
          gameId: 3800131,
          boxGameName: "残照星河大陆"
        },
        {
          seq: 70,
          gameName: "暮雪八荒神器",
          ip: "灬神器追★梦模式",
          line: "▁魔王高爆",
          intro: "※魔王高爆特色玩法多图打宝散人必玩·",
          qq: "经典特色推荐",
          gameId: 3800132,
          boxGameName: "暮雪八荒神器"
        },
        {
          seq: 71,
          gameName: "枯荷嘟嘟专属★",
          ip: "纯◆PC服",
          line: "灬魔王高★爆模式",
          intro: "魔王高爆特色玩法等级好升散人必玩╊",
          qq: "特色推荐爽╊",
          gameId: 3800133,
          boxGameName: "枯荷嘟嘟专属"
        },
        {
          seq: 72,
          gameName: "断猿战神三职业╊",
          ip: "█经典三职首战区",
          line: "多图打宝▃",
          intro: "※多图打宝经典耐玩爆·",
          qq: "特色推荐",
          gameId: 3800140,
          boxGameName: "断猿战神三职业"
        },
        {
          seq: 73,
          gameName: "霁月迷失神器",
          ip: "灬特色单职稳",
          line: "━新职业丰富★",
          intro: "职业丰富等级好升打金服▃",
          qq: "█特色推荐",
          gameId: 3800129,
          boxGameName: "霁月迷失神器"
        },
        {
          seq: 74,
          gameName: "※啼鹃专属大极品",
          ip: "高爆专服散人服",
          line: "▁爆魔王高爆▃",
          intro: "灬魔王高爆特色玩★法装备回收开战",
          qq: "特色推荐〃",
          gameId: 3800135,
          boxGameName: "啼鹃专属大极品"
        },
        {
          seq: 75,
          gameName: "归鸦神器微变▃",
          ip: "灬经典神器追梦",
          line: "泡点升级爆╊",
          intro: "泡点升级专属神器散人服▃",
          qq: "特色推荐爆",
          gameId: 3800134,
          boxGameName: "归鸦神器微变"
        },
        {
          seq: 76,
          gameName: "血池弑神复古",
          ip: "经典三职区★",
          line: "▁真上线领礼▃",
          intro: "上线领礼泡点升级智能挂机燃",
          qq: "升级推荐╊",
          gameId: 3800145,
          boxGameName: "血池弑神复古"
        },
        {
          seq: 77,
          gameName: "朱砂专█属无限刀〃",
          ip: "高爆专服爆",
          line: "经典魔王高爆〃",
          intro: "魔王高爆特色玩法追梦",
          qq: "特色推荐╊",
          gameId: 3800153,
          boxGameName: "朱砂专属无限刀"
        },
        {
          seq: 78,
          gameName: "酒庐火龙复古★",
          ip: "复古◆长服稳",
          line: "━新无坑公平★",
          intro: "无坑公平魔王高爆多图打宝耐玩★",
          qq: "真魔王推荐",
          gameId: 3800159,
          boxGameName: "酒庐火龙复古"
        },
        {
          seq: 79,
          gameName: "刀域复古小极品╊",
          ip: "※经典三职散人服",
          line: "激情攻沙▃",
          intro: "※激情攻沙魔王高爆多图打宝新区首战·",
          qq: "━新魔王推荐★",
          gameId: 3800154,
          boxGameName: "刀域复古小极品"
        },
        {
          seq: 80,
          gameName: "锈刀沉※默三职业╊",
          ip: "经典经典三职",
          line: "等级好升爽",
          intro: "等级好升装备回收多图打宝必玩★",
          qq: "特色◆推荐爽",
          gameId: 3800142,
          boxGameName: "锈刀沉默三职业"
        },
        {
          seq: 81,
          gameName: "▲素霓复古沉默◆",
          ip: "█经典三职爽",
          line: "━真职业丰富★",
          intro: "职业丰富经典耐玩爽〃",
          qq: "爆特色推荐模式",
          gameId: 3800155,
          boxGameName: "素霓复古沉默"
        },
        {
          seq: 82,
          gameName: "道观悟※法专属╊",
          ip: "神器◆追梦",
          line: "█专属神器可搬砖",
          intro: "━专属神器特色玩法多图打宝散人服★",
          qq: "特色推荐激情打宝",
          gameId: 3800161,
          boxGameName: "道观悟法专属"
        },
        {
          seq: 83,
          gameName: "━琴台复古三职业★",
          ip: "▁经典三职散人服",
          line: "职业丰富╊",
          intro: "灬职业丰富神宠助战激情攻沙",
          qq: "特色推荐",
          gameId: 3800156,
          boxGameName: "琴台复古三职业"
        },
        {
          seq: 84,
          gameName: "裂空专属单职业",
          ip: "特色单职",
          line: "灬切割狂暴追梦服",
          intro: "━切割狂暴专属神器魔王高爆散人服★",
          qq: "特色推荐爆╊",
          gameId: 3800143,
          boxGameName: "裂空专属单职业"
        },
        {
          seq: 85,
          gameName: "※无常焚天大陆·",
          ip: "高爆专服▃",
          line: "等级好升可搬砖╊",
          intro: "灬等级好升装备回收多图打宝",
          qq: "特色推荐区",
          gameId: 3800151,
          boxGameName: "无常焚天大陆"
        },
        {
          seq: 86,
          gameName: "█画舫神器专属",
          ip: "神器※追梦╊",
          line: "长久专属神器★",
          intro: "专属神器多图打宝魔王高爆散人必玩",
          qq: "※特色推荐",
          gameId: 3800158,
          boxGameName: "画舫神器专属"
        },
        {
          seq: 87,
          gameName: "灬邪瞳凛★破单职业",
          ip: "▁真特色单职▃",
          line: "※等级好升区",
          intro: "等级好升装█备回收必玩〃",
          qq: "◆特色推·荐玩法",
          gameId: 3800150,
          boxGameName: "邪瞳凛破单职业"
        },
        {
          seq: 88,
          gameName: "禅院天◆命专属",
          ip: "█神器追梦散人服",
          line: "▁专属神器",
          intro: "专属神器特色玩◆法多图打宝刚开服",
          qq: "━真特色推荐★",
          gameId: 3800160,
          boxGameName: "禅院天命专属"
        },
        {
          seq: 89,
          gameName: "墨杀创世微变",
          ip: "神器追梦专服",
          line: "━新专属神器★",
          intro: "※专属神器特色玩法多图打宝新区抢首战",
          qq: "特色推荐╊",
          gameId: 3800162,
          boxGameName: "墨杀创世微变"
        },
        {
          seq: 90,
          gameName: "▁霁月斩墟大极品",
          ip: "经典神◆器追梦",
          line: "※专属神器·",
          intro: "专属神器特色玩◆法多图打宝首战区",
          qq: "特色推荐必体验〃",
          gameId: 3800163,
          boxGameName: "霁月斩墟大极品"
        },
        {
          seq: 91,
          gameName: "墨染神※器单职业╊",
          ip: "特色单职▃",
          line: "※多图打宝追梦服",
          intro: "━多图打宝特色玩法攻速拉满起飞★",
          qq: "特色推荐模式",
          gameId: 3800152,
          boxGameName: "墨染神器单职业"
        },
        {
          seq: 92,
          gameName: "灬黄泉专属单职业",
          ip: "特色单职╊",
          line: "多图打宝追梦服〃",
          intro: "▁多图打宝魔王高爆等级好升爆▃",
          qq: "魔王推荐爽╊",
          gameId: 3800147,
          boxGameName: "黄泉专属单职业"
        }
      ]
    }
  ]
};
